import { Request } from '@group-devs/yfp7-global-modules'
import { FaBars, FaChevronDown } from "react-icons/fa"
import { Navbar, Nav, NavDropdown, Image } from 'react-bootstrap'
import { useState, useEffect } from 'react'
import { WDropdownNav, WMemDropdownNav, WSectionsNav, WCategoriesNav } from '../Block'
import Link from 'next/link'
import { RightSectionNav } from '@group-devs/yfp7-global-modules/components/Block'
//import { RightSectionNav } from '../../backup/components/Block'
import { isDomain } from '@group-devs/yfp7-global-modules/utils/general'

const request = new Request(process.env.apiDomain)

const TopNavUser = (props) => {

    const [contactsId, setContactsId] = useState(null);
    const endPoint = process.env.s3EndPoint.replace('https://','');
    const bucketName = process.env.s3Bucket;
    const IMAGE_PATH = 'https://'+bucketName+'.'+endPoint;

    const contactId = props.auth.site_user ? props.auth.contactId : null
    const userId = props.auth.site_owner ? props.auth.userId : null
    const accountId = props.site ? props.site.accountId : null;

    const {data: hub} = request.website.swrSite(props.site.accountId, "HUB")

    const codes = ["WC-NM","WC-NR","WC-LEC","WC-NA","WC-NV","WC-N-AUDIO","WC-NF","LE-NEWBADGE","LE-NEWPOINTS"];
    // const {data: notifications} = request.notification.notifications(userId, contactId, codes, {is_read: 0})
    const {data: notifications} = request.notification.notifications(userId, contactId, codes)
    
    const {data: profile} = request.account.swrUserProfile(props.auth.site_owner ? props.auth.userId : null);

    const {data: contactAccount} = request.contacts.swrAccount(contactId)
    const avatar = profile && profile.avatar ? profile.avatar : (contactAccount && contactAccount.contact.profile.image != null ? IMAGE_PATH+'/'+contactAccount.contact.profile.image : '/images/default-avatar.png');

    const {data: accountProfileData} = request.account.swrAccountProfileData(props.site.accountId,'account_user_shop_url');

    const shaklee = accountProfileData ? JSON.parse(accountProfileData.data) : '';
    const shakleeUrl = shaklee ? shaklee.shop_url.replace('/storefront','')+'/storefront' : ''

    const [bg, setBg] = useState(false)

    const delay = () => {
        if (bg == true){
            setTimeout(() => {
                setBg(!bg)
            }, 300)
        } else {
            setBg(!bg)
        }
    }

    const [items, setItems] = useState([])

    const {data: accountprofile} = request.account.swrAccountProfile(accountId);
    const {data: shakleeInfo } = request.account.swrShakleeInfo(accountId, accountprofile ? accountprofile.user.id : accountprofile);
    const country = shakleeInfo && shakleeInfo.shaklee_country ? shakleeInfo.shaklee_country : 'us';

    const fetch = async function (){
        if (!props.searchItems) {
            const contents = await request.content.articles({ section: "wellness-center", country: country });
            setItems(contents)
        }
    }

    useEffect(() => {
        fetch()
    }, [])

    const hubDomain = hub ? (isDomain(hub.url) ? 'www.'+hub.url : hub.url) : '';
    const searchItems = props.searchItems || items;

    return (
        <Navbar className={`dashboardtopnav w-100 px-lg-0 px-2 py-lg-0 py-1 ${ bg ? "nav-shadow" : ""} ${ bg ? "bg-white" : "bg-transparent"}`}>
            <WMemDropdownNav site={props}/>
            <WDropdownNav auth={props.auth} site={props.site}/>
            <div className="d-lg-none d-inline-block">
                <Link href="/home" passHref><Nav.Link className=""><Image width={28} className="mr-2" src="/images/general/img-wellness-white-01.svg"/> Wellness Center</Nav.Link></Link>
            </div>

            <RightSectionNav props={props} avatar={avatar} shop={shakleeUrl} notification={notifications} auth={props.auth} site={props.site} origin={"wellness"} items={searchItems} backofficeDomain={process.env.backofficeDomain} />
            
            <div className="d-lg-flex d-none">
                <Link href="/home" passHref><Nav.Link>Home</Nav.Link></Link>
                <WSectionsNav site={props.site} />
                <WCategoriesNav site={props.site} />
                {hub ? <Nav.Link href={`//${hubDomain}/events`} target="_blank">Events</Nav.Link> : null}
            </div>
        
            <style jsx global>{`
               
                .logoToggle .dropdown-item:active{
                    background-color:transparent
                }

                .dropdown-toggle::after{
                    display: none;
                }

                .dashboardtopnav{
                    position:absolute;
                }

                .dashboardtopnav .dropdown-item{
                    font-size:.9rem;
                }

                .navbar-toggler:focus{
                    border:none!important;
                    outline:none!important;
                }

                .navbar-exeption{
                    flex-direction:row;
                }

                .navbar-exeption .nav-link{
                    display:block;
                    padding:.5rem 1rem;
                }

                .nav-shadow .nav-link{
                    color:#232323!important;
                }

                .sectiondropdown .dropdown,
                .member-dropdown .dropdown,
                .categoriesdropdown .dropdown{
                    position:inherit;
                }

                .sectiondropdown .dropdown-menu,
                .member-dropdown .dropdown-menu,
                .categoriesdropdown .dropdown-menu{
                    padding:0;
                    width:100%;
                    min-width:100%;
                    border-radius:0;
                    display:block!important;
                    height:0;
                    transition:height .4s ease-in-out;
                    overflow:hidden;
                    border:none;
                    box-shadow:-1px 9px 9px -3px rgba(0,0,0,0.19);
                }

                .sectiondropdown .dropdown-menu a,
                .member-dropdown .dropdown-menu a,
                .categoriesdropdown .dropdown-menu a{
                    color:#212529;
                }

                .sectiondropdown .dropdown-menu.show{
                    height:230px;
                    transition:height .4s ease-in-out
                }

                .member-dropdown .dropdown-menu.show{
                    height:270px;
                    transition:height .4s ease-in-out
                }

                .categoriesdropdown .dropdown-menu.show{
                    height:235px;
                    transition:height .4s ease-in-out
                }

                .leftNav .dropdown.show .dropdown-toggle svg{
                    transform:rotate(180deg);
                }
                
                @media (min-width: 992px) and (max-width: 1199.98px){

                    .categoriesdropdown .dropdown-menu.show {
                        height: 285px;
                    }

                }

                @media (min-width: 768px) and (max-width: 991.98px){

                }

                @media(max-width:991.98px){

                    .dashboardtopnav{
                        position:fixed;
                        background:#3d8d41!important;
                        border-bottom:1px solid #d5d5d5;
                    }

                    .sectiondropdown .dropdown-menu,
                    .categoriesdropdown .dropdown-menu{
                        box-shadow:none;
                    }

                    .sectiondropdown .dropdown-menu.show{
                        height:calc(100vh - 103px);
                        overflow-y:scroll;
                    }

                    .categoriesdropdown .dropdown-menu.show{
                        height:calc(100vh - 103px);
                        overflow-y:scroll;
                    }

                }
                
                @media(max-width:767.98px){

                    .sectiondropdown .dropdown-menu button img[width="45"],
                    .sectiondropdown .dropdown-menu a img[width="45"]{
                        width:35px;
                    }

                }
                
                @media(max-width:575.98px){

                    .dashboardtopnav,
                    .sectiondropdown .dropdown-menu,
                    .sectiondropdown .dropdown-menu h6,

                    .sectiondropdown .dropdown-menu .btn,
                    .categoriesdropdown .dropdown-menu,
                    .categoriesdropdown .dropdown-menu h6,
                    .categoriesdropdown .dropdown-menu .btn{
                        font-size:0.8rem;
                    }

                }                
                
            `}</style>
        </Navbar>
    )
}

export default TopNavUser